import { Injectable } from '@angular/core';
import { Client, OpenFeature } from '@openfeature/angular-sdk';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private ofClient: Client;

  constructor(private authService: AuthService) {
    this.ofClient = OpenFeature.getClient();
  }

  /**
   * Initialize OpenFeature context from localStorage
   * Should be called on app startup
   */
  async initializeContext(): Promise<void> {
    try {
      const userInfo = this.authService.getUserInfo();

      if (userInfo) {
        const ctx = {
          targetingKey: userInfo.merchantId,
          userID: userInfo.uuid,
          merchant_id: userInfo.merchantId,
        };
        OpenFeature.setContext(ctx);
      }
    } catch (error) {
      console.error('Error initializing OpenFeature context:', error);
      setTimeout(() => this.initializeContext(), 2000);
    }
  }

  /**
   * Get string feature flag value
   */
  async getStringFlag(key: string, defaultValue: string): Promise<string> {
    try {
      const result = this.ofClient.getStringDetails(key, defaultValue);
      return result.value;
    } catch (error) {
      console.error(`Error getting feature flag ${key}:`, error);
      return defaultValue;
    }
  }

  /**
   * Get boolean feature flag value
   */
  async getBooleanFlag(key: string, defaultValue: boolean): Promise<boolean> {
    try {
      const result = this.ofClient.getBooleanDetails(key, defaultValue);
      return result.value;
    } catch (error) {
      console.error(`Error getting feature flag ${key}:`, error);
      return defaultValue;
    }
  }

  /**
   * Get number feature flag value
   */
  async getNumberFlag(key: string, defaultValue: number): Promise<number> {
    try {
      const result = this.ofClient.getNumberDetails(key, defaultValue);
      return result.value;
    } catch (error) {
      console.error(`Error getting feature flag ${key}:`, error);
      return defaultValue;
    }
  }

  /**
   * Get current OpenFeature context
   */
  getContext() {
    return OpenFeature.getContext();
  }
}
